import React from 'react';
import { useTheme } from '@mui/system';
import { oneOfType, bool, string, number } from 'prop-types';
import { getContrastColor } from '#component/theme';
import {
  StyledSvgIcon,
  textStyle,
  checkMarkStyle
} from './styles';

/**
 * Renders circle icon with text inside.
 * Renders check mark if step is completed.
 * @returns {React.FC}
 */

const CustomStepIcon = ({
  active = false,
  completed = false,
  icon = ''
}) => {
  const theme = useTheme();

  return (
    <StyledSvgIcon
      isActive={active}
      isCompleted={completed}
      htmlColor={completed ? getContrastColor() : theme.palette.grey[300]}
    >
      <circle cx="12" cy="12" r="11" />
      {completed ? (
        <path d="M 10.136 15.138 L 7.287 12.281 L 6.338 13.232 L 10.136 17.041 L 18.273 8.882 L 17.324 7.929 L 10.136 15.138 Z" style={checkMarkStyle(theme)} />
      ) : (
        <text style={textStyle(theme)} x="12" y="16" textAnchor="middle">{icon}</text>
      )}

    </StyledSvgIcon>
  );
};

CustomStepIcon.propTypes = {
  active: bool,
  completed: bool,
  icon: oneOfType([string, number])
};

export default CustomStepIcon;
